(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';

      this.headerBounds = {};
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');

        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;

          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });

      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
				if (disclosure) {
					disclosure.close()
				}
			}
			);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-personalizado-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('personalized-product-v2')) {
    customElements.define(
      'personalized-product-v2',
      class PersonalizedProductV2 extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-personalizado-variants]').textContent);
          this.optionInputs = Array.from(this.querySelectorAll('[data-personalizado-option]'));
          this.variantInput = this.querySelector('input[name="id"]');
          this.price = this.querySelector('[data-personalizado-price]');
          this.pricePrefix = this.querySelector('[data-personalizado-price-prefix]');
          this.comparePrice = this.querySelector('[data-personalizado-compare]');
          this.selection = this.querySelector('[data-personalizado-selection]');
          this.submit = this.querySelector('[data-personalizado-submit]');
          this.submitLabel = this.querySelector('[data-personalizado-submit-label]');
          this.headerWrapper = document.querySelector('.section-header .header-wrapper');
          this.updateHeaderClearance = this.updateHeaderClearance.bind(this);

          this.updateHeaderClearance();
          requestAnimationFrame(this.updateHeaderClearance);
          window.addEventListener('resize', this.updateHeaderClearance);
          if (this.headerWrapper && 'ResizeObserver' in window) {
            this.headerResizeObserver = new ResizeObserver(this.updateHeaderClearance);
            this.headerResizeObserver.observe(this.headerWrapper);
          }

          this.optionInputs.forEach((input) => input.addEventListener('change', () => this.updateVariant()));
          this.querySelectorAll('[data-personalizado-media]').forEach((button) => {
            button.addEventListener('click', () => this.selectMedia(button));
          });

          const selectedVariantId = Number(this.dataset.selectedVariantId || 0);
          if (selectedVariantId) {
            const selectedVariant = this.variants.find((variant) => Number(variant.id) === selectedVariantId);
            if (selectedVariant) this.selectVariantOptions(selectedVariant);
          }

          if (this.variants.length === 1) {
            this.applyVariant(this.variants[0]);
          } else {
            this.updateVariant();
          }
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.updateHeaderClearance);
          if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
        }

        updateHeaderClearance() {
          if (!this.headerWrapper) return;
          const headerSection = this.headerWrapper.closest('.section-header');
          const isCoverHeader = headerSection && headerSection.classList.contains('shopify-section-header-cover');
          let clearance = 0;

          if (isCoverHeader) {
            const wrapperTop = Number.parseFloat(window.getComputedStyle(this.headerWrapper).top) || 0;
            clearance = Math.max(0, Math.ceil(wrapperTop + this.headerWrapper.offsetHeight));
          } else if (window.scrollY < 2) {
            const headerBottom = this.headerWrapper.getBoundingClientRect().bottom;
            const sectionTop = this.getBoundingClientRect().top;
            clearance = Math.max(0, Math.ceil(headerBottom - sectionTop));
          }

          this.style.setProperty('--personalizado-v2-header-clearance', `${clearance}px`);
        }

        selectVariantOptions(variant) {
          variant.options.forEach((value, index) => {
            const input = this.optionInputs.find(
              (candidate) => Number(candidate.dataset.optionPosition) === index + 1 && candidate.value === value
            );
            if (input) input.checked = true;
          });
          this.updateVariant();
        }

        selectedOptions() {
          const selected = [];
          this.optionInputs.forEach((input) => {
            if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
          });
          return selected;
        }

        updateVariant() {
          const selected = this.selectedOptions();
          const optionCount = this.querySelectorAll('fieldset[data-option-position]').length;
          const isComplete = selected.filter(Boolean).length === optionCount;
          const variant = isComplete
            ? this.variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]))
            : null;

          this.updateOptionAvailability(selected);
          this.applyVariant(variant);
        }

        updateOptionAvailability(selected) {
          this.optionInputs.forEach((input) => {
            const hypothetical = [...selected];
            hypothetical[Number(input.dataset.optionPosition) - 1] = input.value;
            const possible = this.variants.some(
              (variant) => variant.available && hypothetical.every((value, index) => !value || variant.options[index] === value)
            );
            input.disabled = !possible && !input.checked;
          });
        }

        applyVariant(variant) {
          if (!variant) {
            this.variantInput.value = '';
            this.submit.disabled = true;
            this.submitLabel.textContent = this.dataset.selectionLabel;
            if (this.selection) {
              this.selection.textContent = this.dataset.selectionMessage;
              this.selection.hidden = true;
            }
            this.pricePrefix.hidden = false;
            this.comparePrice.hidden = true;
            return;
          }

          this.variantInput.value = variant.id;
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.price.textContent = variant.formattedPrice;
          this.pricePrefix.hidden = true;
          if (this.selection) {
            this.selection.textContent = variant.title;
            this.selection.hidden = false;
          }

          if (variant.compareAtPrice > variant.price) {
            this.comparePrice.textContent = variant.formattedCompareAtPrice;
            this.comparePrice.hidden = false;
          } else {
            this.comparePrice.hidden = true;
          }

          if (variant.available) {
            this.submit.disabled = false;
            this.submitLabel.textContent = `${this.dataset.addLabel} — ${variant.formattedPrice}`;
          } else {
            this.submit.disabled = true;
            this.submitLabel.textContent = this.dataset.soldOutLabel;
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        selectMedia(button) {
          const image = this.querySelector('.personalizado-v2__main-image');
          if (!image) return;
          image.removeAttribute('srcset');
          image.src = button.dataset.src;
          image.alt = button.dataset.alt || '';
          this.querySelectorAll('[data-personalizado-media]').forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            if (active) candidate.setAttribute('aria-current', 'true');
            else candidate.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-faq-closing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-personalized-sticky]').forEach((sticky) => {
    const hero = document.querySelector('[data-personalized-hero]');
    const targetSelector = sticky.getAttribute('href');
    const target = targetSelector ? document.querySelector(targetSelector) : null;
    let heroVisible = true;
    let targetVisible = false;

    const update = () => {
      sticky.classList.toggle('is-visible', !heroVisible && !targetVisible);
    };

    if (hero && 'IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver((entries) => {
        heroVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.08 });
      heroObserver.observe(hero);
    }

    if (target && 'IntersectionObserver' in window) {
      const targetObserver = new IntersectionObserver((entries) => {
        targetVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.15 });
      targetObserver.observe(target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-v2-proof-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-personalized-v2-sticky]').forEach((sticky) => {
    const hero = document.querySelector('[data-personalized-v2-hero]');
    const selector = document.querySelector('#personalizados-v2-selector');
    let heroVisible = true;
    let selectorVisible = false;

    const update = () => {
      sticky.classList.toggle('is-visible', !heroVisible && !selectorVisible);
    };

    if (hero) {
      new IntersectionObserver(([entry]) => {
        heroVisible = entry.isIntersecting;
        update();
      }, { threshold: 0.08 }).observe(hero);
    } else {
      heroVisible = false;
    }

    if (selector) {
      new IntersectionObserver(([entry]) => {
        selectorVisible = entry.isIntersecting;
        update();
      }, { threshold: 0.02 }).observe(selector);
    }

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
